import { useState, createContext, useCallback } from "react";

import { Notification } from "../components";
import { NOTIFICATION_TYPES } from "../utils";
// Direct util import (not useAnalytics): ToastProvider can mount above the
// auth context, and error telemetry must not depend on provider order.
import { trackEvent } from "../utils/posthog";

export const ToastContext = createContext({
  addToast: () => {},
  removeToast: () => {},
});

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const addToast = useCallback(
    ({ type = Notification.types.info, content, timeout = 5000 }) => {
      const id = Date.now();
      setToasts((prevToasts) => [...prevToasts, { id, type, content }]);

      if (type === NOTIFICATION_TYPES.error) {
        // Single choke point for user-visible API failures. content may be a
        // React node; only string messages are sent (capped — error text can
        // embed customer data, so keep it short and identifiable, not full).
        trackEvent("error_toast_shown", {
          path: window.location.pathname,
          ...(typeof content === "string"
            ? { message: content.slice(0, 120) }
            : { content_type: "node" }),
        });
      }

      setTimeout(() => {
        removeToast(id);
      }, timeout);
    },
    [removeToast],
  );

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <div className="fixed right-0 top-0 space-y-4 p-4">
        {toasts.map(({ id, content, type }) => (
          <Notification
            key={id}
            content={content}
            type={type}
            onClear={() => removeToast(id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};
